const URL_TEXTCOLOR_OPTIONS_OF_DROPS = [
  {
    name: "drop#01",
    items: [
      {
        name: "BLACK",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_01_with_Grey_Background.jpg?v=1764224134"
      },
      {
        name: "WHITE",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_01_with_Grey_Background.jpg?v=1764224134"
      },
      {
        name: "YELLOW",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_01_with_Grey_Background.jpg?v=1764224134"
      },
      {
        name: "GREEN",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_01_with_Grey_Background.jpg?v=1764224134"
      },
      {
        name: "ORANGE",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_01_with_Grey_Background.jpg?v=1764224134"
      },
      {
        name: "PINK",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_01_with_Grey_Background.jpg?v=1764224134"
      },
    ],
  },
  {
    name: "drop#02",
    items: [
      {
        name: "BLACK",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_02_with_Grey_Background.jpg?v=1764224134"
      },
      {
        name: "WHITE",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_02_with_Grey_Background.jpg?v=1764224134"
      },
      {
        name: "PINK",
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_02_with_Grey_Background.jpg?v=1764224134"
      },
    ],
  },
  {
    "name": "drop#03",
    "items": [
      {
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_03_with_Grey_Background.jpg?v=1764224134",
        name: "BLACK"
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_03_with_Grey_Background.jpg?v=1764224134",
        name: "WHITE"
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_03_with_Grey_Background.jpg?v=1764224134",
        name: "PINK"
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_03_with_Grey_Background.jpg?v=1764224134",
        name: "ORANGE"
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_03_with_Grey_Background.jpg?v=1764224134",
        name: "LIGHT BLUE"
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_03_with_Grey_Background.jpg?v=1764224134",
        name: "DARK BLUE"
      }
    ]
  }
];
